export const isDevelopmentEnv = () => process.env.NODE_ENV === 'development';
